import HeroSection from "@/components/HeroSection";
import AIAdvantageSection from "@/components/AIAdvantageSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import PricingSection from "@/components/PricingSection";
import GuaranteeSection from "@/components/GuaranteeSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import WebsiteTypesSection from "@/components/WebsiteTypesSection";
import ShowcaseSection from "@/components/ShowcaseSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import AnimateOnScroll from "@/components/AnimateOnScroll";
import ScrollToTop from "@/components/ScrollToTop";
import StickyCTA from "@/components/StickyCTA";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <AnimateOnScroll variant="zoom" delay={0} once={false}>
        <HeroSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom" delay={0} once={false}>
        <WebsiteTypesSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom" delay={0} once={false}>
        <AIAdvantageSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom" delay={0} once={false}>
        <ShowcaseSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom" delay={0} once={false}>
        <TestimonialsSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom" delay={0} once={false}>
        <HowItWorksSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom" delay={0} once={false}>
        <PricingSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom" delay={0} once={false}>
        <GuaranteeSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom" delay={0} once={false}>
        <FAQSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom" delay={0} once={false}>
        <ContactSection />
      </AnimateOnScroll>
      <Footer />
      <ScrollToTop />
      <StickyCTA />
    </div>
  );
};

export default Index;
